// import React, { useEffect, useRef, useState } from 'react'
// import '../css/layout.css'
// import css from '../Modulecss/Home.module.css'
// import axios from 'axios'
// import { Link, useHistory, useLocation } from 'react-router-dom'
// import Swal from 'sweetalert2'
// import Rightcontainer from '../Components/Rightcontainer'
// import BetCard from './BetCard'
// import RunningCard from './RunningCard'
// import Header from '../Components/Header'
// import io from '../Components/socket'
// import socket from '../Components/socket'
// import { addResponseMessage } from "react-chat-widget";
// import BotTable from './BotTable'
// export default function Homepage({ walletUpdate }) {
//   const history = useHistory()
//   let userID = useRef()
//   let str
//   /// user details start

//   const [user, setUser] = useState()
//   const [created, setCreated] = useState([])
//   const [challangeReqRun, setChallangeReqRun] = useState(false)

//   const [game_amount, setGame_amt] = useState()

//   const [userAllData, setUserAllData] = useState()

//   const [gameData, setGameData] = useState({})

//   const [submitProcess, setProcess] = useState(true)
//   const [isLoading, setIsloading] = useState(false)
//   const [addCaseSetting, setaddCaseSetting] = useState()
//   // const addsetting = localStorage.getItem('sitSetting')
//   // const addCaseSetting = JSON.parse(addsetting)

//   const access_token = localStorage.getItem('token')

//   const role = async () => {
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//     await axios
//       .get(`https://api.kakaking.in/me`, { headers })
//       .then(res => {
//         setUser(res.data._id)
//         setUserAllData(res.data)
//         userID.current = res.data._id
//         setMount(true)
//       })
//       .catch(e => {
//         if (e.response.status === 401) {
//           localStorage.removeItem('token')
//           // window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e.response.status === 400 || e.response.status === 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }


//   useEffect(() => {
//     socket.emit('websetting')
//   }, [])
//   useEffect(() => {
//     socket.on("websettingGet", (data) => {
//       localStorage.setItem("sitSetting", JSON.stringify(data));
//       setaddCaseSetting(data);
//     });

//     socket.on("recive-msg", (msgs) => {
//       if (msgs?.sender !== user?._id) addResponseMessage(msgs.text);
//     });
//   }, []);
//   /// user details end
//   // console.log(useLocation().pathname.split('/')[2], '  useLocation().pathname')
//   const [game_type, setGame_type] = useState(
//     useLocation().pathname.split('/')[2]
//   )
//   const [game_type2, setGame_type2] = useState(
//     useLocation().pathname.split('/')[2]
//   )
//   const [Game_Ammount, setGame_Ammount] = useState('')

//   //   console.log(game_type);

//   const ChallengeCreate = e => {
//     setIsloading(true)
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .post(
//         'https://api.kakaking.in/challange/create',
//         {
//           Game_Ammount,
//           Game_type: game_type
//         },
//         { headers }
//       )
//       .then(res => {
//         setGame_amt(res?.data?.data?.Game_Ammount)

//         if (res.data.status == false) {
//           setIsloading(false)
//           Swal.fire({
//             title: res.data.msg,
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (res.data.msg === 'you have already enrolled') {
//           setIsloading(false)
//           Swal.fire({
//             title: 'You have already enrolled',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (res.data.msg === 'You can set maximum 2 battle.') {
//           setIsloading(false)
//           Swal.fire({
//             title: 'You can set maximum 2 battle.',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (res.data.msg === 'Insufficient balance') {
//           setIsloading(false)
//           Swal.fire({
//             title: 'Insufficient balance',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (
//           res.data.msg ===
//           'Game amount should be Greater then 50 and less then 50000'
//         ) {
//           setIsloading(false)
//           Swal.fire({
//             title: 'Game amount should be Greater then 50 and less then 50000',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (res.data.msg === 'Set Battle in denomination of 50') {
//           setIsloading(false)
//           Swal.fire({
//             title: 'Set Battle in denomination of 50',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (res.data.msg === 'Technical Issue, Try after an hour!') {
//           setIsloading(false)
//           Swal.fire({
//             title: 'Technical Issue, Try after an hour!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else {
//           setIsloading(false)
//           // Allgames();
//           // io.emit("gameCreated");
//         }
//       })
//       .catch(e => {
//         setIsloading(false)
//         if (e?.response?.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e?.response?.status == 400 || e?.response?.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//         console.log(e)
//       })
//   }

//   const [allgame, setallgame] = useState([])
//   const [mount, setMount] = useState(false)
//   const [ALL, setALL] = useState()
//   const [runningGames, setRunningGames] = useState([])
//   const [ownRunning, setOwnRunning] = useState([])

//   const Allgames = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//     axios
//       .get('https://api.kakaking.in/challange/all', { headers })
//       .then(res => {
//         let owenedCreated = [],
//           remainingGame = []
//         res.data.forEach(function (ele) {
//           if (
//             ele.Created_by._id == user &&
//             (ele.Status == 'new' || ele.Status == 'requested')
//           ) {
//             owenedCreated.push(ele)
//           } else {
//             remainingGame.push(ele)
//           }
//         })
//         setCreated(owenedCreated)
//         setallgame(remainingGame)
//       })
//       .catch(e => {
//         if (e?.response?.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e?.response?.status == 400 || e?.response?.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }

//   const runningGame = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .get('https://api.kakaking.in/challange/running/all', { headers })
//       .then(res => {
//         let owenedRunning = [],
//           remainingRunning = []
//         res.data.forEach(function (ele) {
//           if (ele.Created_by && ele.Accepetd_By)
//             if (
//               ele.Created_by?._id == userID.current ||
//               ele.Accepetd_By?._id == userID.current
//             ) {
//               owenedRunning.push(ele)
//             } else {
//               remainingRunning.push(ele)
//             }
//         })
//         setOwnRunning(owenedRunning)
//         setRunningGames(remainingRunning)
//       })
//       .catch(e => {
//         console.log('errror', e)
//         if (e.response?.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           // window.location.reload()
//           //    setTimeout(() => {
//           // //  history.push("/login")
//           // }, 500);
//         }
//         if (e.response?.status == 400 || e.response?.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }






//   function winnAmount(gameAmount) {
//     let profit = 0;

//     const commissionLudo = addCaseSetting?.commissionRangeludo || 10; // for 50–500
//     const commissionAbove500 = addCaseSetting?.commissionRange2 || 5; // for >500
//     if (gameAmount >= 50 && gameAmount <= 500) {
//       profit = (gameAmount * commissionLudo) / 100; // use commissionRangeludo
//     } else if (gameAmount > 500) {
//       profit = (gameAmount * commissionAbove500) / 100; // use commissionRange2
//     }

//     return gameAmount - profit;
//   }

//   useEffect(() => {
//     io.on('gamelist', data => {

//       let owenedCreated = [],
//         remainingGame = []
//       data.forEach(function (ele) {
//         if (ele.Created_by)
//           if (
//             ele.Created_by._id == userID.current &&
//             (ele.Status == 'new' || ele.Status == 'requested')
//           ) {
//             owenedCreated.push(ele)
//           } else {
//             remainingGame.push(ele)
//           }
//       })
//       // console.log('own',owenedCreated,'remiain',remainingGame);
//       setCreated(owenedCreated)
//       setallgame(remainingGame)
//     })

//     io.on('resultUpdateReq', data => {
//       // console.log('resultUpdateReq')
//       let owenedRunning = [],
//         remainingRunning = []
//       data.forEach(function (ele) {
//         if (ele.Created_by && ele.Accepetd_By)
//           if (
//             ele.Created_by._id == userID.current ||
//             ele.Accepetd_By._id == userID.current
//           ) {
//             owenedRunning.push(ele)
//           } else {
//             remainingRunning.push(ele)
//           }
//       })
//       setOwnRunning(owenedRunning)
//       setRunningGames(remainingRunning)
//       walletUpdate()
//     })
//     io.on('startAcepptor', data => {
//       // console.log('startAcepptor',data)
//       let owenedCreated = [],
//         remainingGame = []
//       data.forEach(function (ele) {
//         if (ele.Created_by)
//           if (
//             ele.Created_by._id == userID.current &&
//             (ele.Status == 'new' || ele.Status == 'requested')
//           ) {
//             owenedCreated.push(ele)
//           } else {
//             remainingGame.push(ele)
//           }
//       })
//       setCreated(owenedCreated)
//       setallgame(remainingGame)
//       walletUpdate()
//     })

//     io.on('acceptor_seen', data => {
//       // console.log('acceptor_seen',data)
//       let owenedCreated = [],
//         remainingGame = []
//       data.openBattle.forEach(function (ele) {
//         if (ele.Created_by)
//           if (
//             ele.Created_by._id == userID.current &&
//             (ele.Status == 'new' || ele.Status == 'requested')
//           ) {
//             owenedCreated.push(ele)
//           } else {
//             remainingGame.push(ele)
//           }
//       })
//       setCreated(owenedCreated)
//       setallgame(remainingGame)
//       let owenedRunning = [],
//         remainingRunning = []
//       data.runningBattle.forEach(function (ele) {
//         if (ele.Created_by && ele.Accepetd_By)
//           if (
//             ele.Created_by._id == userID.current ||
//             ele.Accepetd_By._id == userID.current
//           ) {
//             owenedRunning.push(ele)
//           } else {
//             remainingRunning.push(ele)
//           }
//       })
//       setOwnRunning(owenedRunning)
//       setRunningGames(remainingRunning)
//       walletUpdate()
//     })
//   }, [io])

//   useEffect(() => {
//     let access_token = localStorage.getItem('token')
//     access_token = localStorage.getItem('token')
//     if (!access_token) {
//       window.location.reload()
//       setTimeout(() => {
//         //  history.push("/login")
//       }, 500)
//     }
//     role()
//     if (mount) {
//       Allgames()
//       runningGame()
//     }
//     return () => {
//       role()
//     }
//   }, [mount])
//   //accept Challange

//   const AcceptChallang = id => {
//     if (str == 1) {
//       Swal.fire({
//         title: 'Other request in process',
//         icon: 'warning',
//         confirmButtonText: 'OK'
//       })
//     }
//     str = 1
//     const access_token = localStorage.getItem('token')

//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .put(
//         `https://api.kakaking.in/challange/accept/${id}`,
//         {
//           Accepetd_By: headers,
//           Acceptor_by_Creator_at: Date.now()
//         },
//         {
//           headers
//         }
//       )
//       .then(res => {
//         setGameData({
//           accept_by: res.data.Accepetd_By,
//           created_by: res.data.Created_by
//         })

//         str = 0
//         if (res.data.status === false) {
//           Swal.fire({
//             title: res.data.msg,
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//         if (res.data.msg === 'you have already enrolled') {
//           Swal.fire({
//             title: 'You have already enrolled',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//         if (res.data.msg === 'Insufficient balance') {
//           Swal.fire({
//             title: 'Insufficient balance',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else {
//           // Allgames(res.data)
//         }
//       })
//       .catch(e => {
//         console.log(e)
//         if (e.response.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e.response.status == 400 || e.response.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }

//   //reject Game
//   const RejectGame = id => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .put(
//         `https://api.kakaking.in/challange/reject/${id}`,
//         {
//           Accepetd_By: null,
//           Status: 'new',
//           Acceptor_by_Creator_at: null
//         },
//         { headers }
//       )
//       .then(res => {
//         // io.emit("gameRejected");
//       })
//       .catch(e => {
//         console.log(e)
//         if (e.response.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e.response.status == 400 || e.response.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }

//   //delete
//   const deleteChallenge = _id => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .delete(`https://api.kakaking.in/challange/delete/${_id}`, {
//         headers
//       })
//       .then(res => {
//         if (res.data.status == false) {
//           Swal.fire({
//             title: res.data.msg,
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//         // io.emit("deleteGame", _id);
//       })
//       .catch(e => {
//         if (e?.response?.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e.response.status == 400 || e.response.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }

//   ///challange/running/update/

//   const updateChallenge = _id => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .put(
//         `https://api.kakaking.in/challange/running/update/${_id}`,
//         {
//           Acceptor_seen: true
//         },
//         { headers }
//       )
//       .then(res => {
//         // io.emit("game_seen");
//       })
//       .catch(e => {
//         if (e.response.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e.response.status == 400 || e.response.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//         console.log(e)
//       })
//   }

//   // const [roomCode, setRoomCode] = useState()

//   const getPost = async Id => {
//     if (
//       game_type === 'Ludo Classics' ||
//       game_type === 'Ludo 1 Goti' ||
//       game_type === 'Ludo Ulta' ||
//       // game_type === "Ludo Popular" ||
//       game_type === 'Ludo Host'
//     ) {
//       if (submitProcess) {
//         setProcess(false)
//         setChallangeReqRun(true)

//         const access_token = localStorage.getItem('token')

//         const headers = {
//           authorization: `Bearer ${access_token}`
//         }

//         axios
//           .patch(
//             `https://api.kakaking.in/challange/requested/running/${game_type}/` +
//             Id,
//             {},
//             { headers }
//           )
//           .then(res => {
//             setProcess(true)
//             setChallangeReqRun(false)
//             if (res.data.status == false) {
//               Swal.fire({
//                 title: res.data.msg,
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             } else {
//               localStorage.setItem('timeOver', 'timeStart')
//               history.push(`/viewgame1/${Id}`, {
//                 prevPath: window.location?.pathname
//               })
//             }
//           })
//           .catch(e => {
//             setProcess(true)
//             setChallangeReqRun(false)
//             if (e?.response?.status == 401) {
//               Swal.fire({
//                 title: 'Somthing wrong',
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             } else {
//               Swal.fire({
//                 title: 'Please refresh!',
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             }
//           })
//       }

//     } else if (
//       game_type === 'LudoSnake' ||
//       game_type === 'Ludo Popular' ||
//       game_type === 'ludoClassicManual'
//     ) {
//       if (submitProcess) {
//         setProcess(false)
//         setChallangeReqRun(true)

//         const access_token = localStorage.getItem('token')

//         const headers = {
//           authorization: `Bearer ${access_token}`
//         }

//         axios
//           .patch(
//             'https://api.kakaking.in/challange/requested/running/' + Id,
//             {},
//             { headers }
//           )
//           .then(res => {
//             setProcess(true)
//             setChallangeReqRun(false)
//             if (res.data.status == false) {
//               Swal.fire({
//                 title: res.data.msg,
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             } else {
//               localStorage.setItem('timeOver', 'timeStart')
//               history.push(`/viewgame1/${Id}`, {
//                 prevPath: window.location?.pathname
//               })
//             }
//           })
//           .catch(e => {
//             setProcess(true)
//             setChallangeReqRun(false)
//             if (e?.response?.status == 401) {
//               Swal.fire({
//                 title: 'Somthing wrong',
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             } else {
//               Swal.fire({
//                 title: 'Please refresh!',
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             }
//           })
//       }
//     }
//   }

//   const [siteSetting, setsiteSetting] = useState([])

//   useEffect(() => {
//     const items = JSON.parse(localStorage.getItem('sitSetting'))
//     if (items) {
//       setsiteSetting(items)
//     }
//   }, [])

//   const [botTable, setBotTable] = useState([]);

//   const getRandomSet = async () => {
//     try {
//       const access_token = localStorage.getItem("token");

//       const res = await axios.get("https://api.kakaking.in/randomset", {
//         headers: { Authorization: `Bearer ${access_token}` },
//       });

//       if (res.data.status === "success") {
//         setBotTable(res.data.players);
//       }
//     } catch (err) {
//       console.error("Error fetching random set:", err);
//     }
//   };

//   useEffect(() => {
//     getRandomSet();
//   }, []);

//   return (
//     <>
//       <Header user={userAllData} />
//       <div className='leftContainer' style={{ minHeight: '100vh', }}>
//         <div className='pt-5 mt-5 Orher_page_main_section' style={{ paddingBottom: "80px" }} >
//           <div className="site_message_main" style={{
//             background: "#000000",
//             color: '#fff',
//             borderRadius: '12px',
//             padding: '1px 10px',
//             marginBottom: '20px',

//             border: "5px solid rgb(211 170 88)"
//           }}>
//             <p>{siteSetting.ludoClassicsMsg}</p>
//           </div>
//           {/* create a battle input  box */}
//           <div className='rules_btn d-flex justify-content-end'>
//             <Link to="/Rules">Rules</Link>

//           </div>
//           {(siteSetting?.gameSearch) && (
//             <>
//               <div className="create_battle_main_div corona-gradient-card ">
//                 <div className="form-group">
//                   <label>Open Battle !</label>
//                 </div>

//                 <div
//                   className="craete_battle_input"
//                   style={{ position: "relative" }}
//                 >
//                   <input
//                     type="text"
//                     className="form-control common_input_box"
//                     placeholder="Enter Amount"
//                     inputMode="numeric"
//                     value={Game_Ammount}
//                     onChange={e => setGame_Ammount(e.target.value)}
//                   />

//                   {isLoading ? (
//                     <img
//                       src="/images/LandingPage_img/old-loader1.gif"
//                       style={{
//                         height: "30px",
//                         width: "30px",
//                         position: "absolute",
//                         right: "10px",
//                         top: "50%",
//                         transform: "translateY(-50%)",
//                       }}
//                       className="img-fluid create_battle_loader"
//                     />
//                   ) : (
//                     <button
//                       className="create_battle_btn"
//                       onClick={(e) => {
//                         e.preventDefault();
//                         setGame_Ammount("");
//                         ChallengeCreate();
//                       }}
//                       style={{
//                         position: "absolute",
//                         right: "1px",
//                         top: "50%",
//                         transform: "translateY(-50%)",
//                         height: "30px",
//                         padding: "0 12px",
//                         borderRadius: "6px",
//                         border: "none",
//                         background: "#0b2c22",
//                         color: "#fff",
//                         cursor: "pointer",
//                       }}
//                     >
//                       Set
//                     </button>


//                   )}
//                 </div>
//               </div>
//             </>
//           )}
//           <div className={css.dividerX}></div>
//           {/* <div  className="open_battle_headings">
//             <h3 >
//               <img src={process.env.PUBLIC_URL + '/images/Homepage/battleIcon.png'} className="img-fluid" />
//               Open Battles
//             </h3>
//           </div> */}
//           <div className="open_battle_headings">
//             <span style={{ textAlign: "center", width: "100%", fontSize: "19px", fontWeight: "500" }}>
//               <img
//                 src={process.env.PUBLIC_URL + '/images/battleIconbg.png'}
//                 style={{ verticalAlign: "middle", marginRight: "6px" }}
//               />
//               Open Battles
//             </span>
//           </div>

//           <div className=''>
//             {created &&
//               created.map(
//                 allgame =>
//                   allgame.Game_type == game_type && (
//                     <BetCard
//                       key={allgame._id}
//                       allgame={allgame}
//                       user={user}
//                       deleteChallenge={deleteChallenge}
//                       getPost={getPost}
//                       RejectGame={RejectGame}
//                       challangeReqRun={challangeReqRun}
//                       winnAmount={winnAmount}
//                       AcceptChallang={AcceptChallang}
//                       updateChallenge={updateChallenge}
//                     />
//                   )
//               )}
//             {allgame &&
//               allgame.map(
//                 allgame =>
//                   (allgame.Status == 'new' ||
//                     (allgame.Status == 'requested' &&
//                       (user == allgame.Created_by._id ||
//                         user == allgame?.Accepetd_By?._id)) ||
//                     (allgame?.Status == 'running' &&
//                       user == allgame?.Accepetd_By?._id &&
//                       allgame.Acceptor_seen == false)) &&
//                   allgame.Game_type == game_type && (
//                     <BetCard
//                       key={allgame._id}
//                       allgame={allgame}
//                       user={user}
//                       deleteChallenge={deleteChallenge}
//                       getPost={getPost}
//                       RejectGame={RejectGame}
//                       winnAmount={winnAmount}
//                       AcceptChallang={AcceptChallang}
//                       updateChallenge={updateChallenge}
//                     />
//                   )
//               )}
//           </div>
//           <div className="battle_devider"></div>
//           <div className=''>
//             <div className="open_battle_headings">
//               <span style={{ textAlign: "center", width: "100%", fontSize: "19px", fontWeight: "500" }}>
//                 <img
//                   src={process.env.PUBLIC_URL + '/images/battleIcon.png'}
//                   className="img-fluid"
//                   style={{ verticalAlign: "middle", marginRight: "6px" }}
//                 />
//                 Running Battles
//               </span>
//             </div>

//             {ownRunning &&
//               ownRunning.map(runnig => {
//                 if (
//                   ((user == runnig.Accepetd_By._id
//                     ? (runnig.Status === 'running' &&
//                       user == runnig.Accepetd_By._id &&
//                       runnig.Acceptor_seen == true) ||
//                     runnig.Status === 'pending'
//                     : (runnig.Status === 'running' &&
//                       user == runnig.Created_by._id) ||
//                     runnig.Status === 'pending') ||
//                     runnig.Status == 'conflict') &&
//                   runnig.Game_type == game_type
//                 )
//                   return (
//                     <RunningCard
//                       key={runnig._id}
//                       runnig={runnig}
//                       user={user}
//                       winnAmount={winnAmount}
//                     />
//                   )
//               })}

//             {runningGames &&
//               runningGames.map(runnig => {
//                 if (
//                   (user == runnig.Accepetd_By._id ||
//                     user == runnig.Created_by._id
//                     ? user == runnig.Accepetd_By._id
//                       ? (runnig.Status === 'running' &&
//                         user == runnig.Accepetd_By._id &&
//                         runnig.Acceptor_seen == true) ||
//                       (runnig.Status === 'pending' &&
//                         runnig.Acceptor_status == null)
//                       : (runnig.Status === 'running' &&
//                         user == runnig.Created_by._id) ||
//                       (runnig.Status === 'pending' &&
//                         runnig.Creator_Status == null)
//                     : runnig.Status === 'running' ||
//                     runnig.Status === 'pending') &&
//                   runnig.Game_type == game_type
//                 ) {
//                   return (
//                     <>
//                       <RunningCard
//                         key={runnig._id}
//                         runnig={runnig}
//                         user={user}
//                         winnAmount={winnAmount}
//                       />
//                     </>
//                   )
//                 }
//               })}



//             {botTable &&
//               botTable.map((running, index) => (
//                 <BotTable key={index} running={running} winnAmount={winnAmount} />
//               ))}

//           </div>
//         </div>
//       </div>
//       <div className='rightContainer'>
//         <Rightcontainer />
//       </div>
//     </>
//   )
// }


import React, { useEffect, useRef, useState } from 'react'
import '../css/layout.css'
// import './HomepagePremium.css'
import css from '../Modulecss/Home.module.css'
import axios from 'axios'
import { Link, useHistory, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import Rightcontainer from '../Components/Rightcontainer'
import BetCard from './BetCard'
import RunningCard from './RunningCard'
import Header from '../Components/Header'
import io from '../Components/socket'
import socket from '../Components/socket'
import { addResponseMessage } from "react-chat-widget";
import BotTable from './BotTable'
export default function Homepage({ walletUpdate }) {
  const history = useHistory()
  let userID = useRef()
  let str
  /// user details start

  const [user, setUser] = useState()
  const [created, setCreated] = useState([])
  const [challangeReqRun, setChallangeReqRun] = useState(false)

  const [game_amount, setGame_amt] = useState()

  const [userAllData, setUserAllData] = useState()

  const [gameData, setGameData] = useState({})

  const [submitProcess, setProcess] = useState(true)
  const [isLoading, setIsloading] = useState(false)
  const [addCaseSetting, setaddCaseSetting] = useState()
  // const addsetting = localStorage.getItem('sitSetting')
  // const addCaseSetting = JSON.parse(addsetting)

  const access_token = localStorage.getItem('token')

  const role = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    await axios
      .get(`https://api.kakaking.in/me`, { headers })
      .then(res => {
        setUser(res.data._id)
        setUserAllData(res.data)
        userID.current = res.data._id
        setMount(true)
      })
      .catch(e => {
        if (e.response.status === 401) {
          localStorage.removeItem('token')
          // window.location.reload()
          setTimeout(() => {
            //  history.push("/login")
          }, 500)
        }
        if (e.response.status === 400 || e.response.status === 429) {
          Swal.fire({
            title: 'Please refresh!',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
      })
  }


  useEffect(() => {
    socket.emit('websetting')
  }, [])
  useEffect(() => {
    socket.on("websettingGet", (data) => {
      localStorage.setItem("sitSetting", JSON.stringify(data));
      setaddCaseSetting(data);
    });

    socket.on("recive-msg", (msgs) => {
      if (msgs?.sender !== user?._id) addResponseMessage(msgs.text);
    });
  }, []);
  /// user details end
  // console.log(useLocation().pathname.split('/')[2], '  useLocation().pathname')
  const [game_type, setGame_type] = useState(
    useLocation().pathname.split('/')[2]
  )
  const [game_type2, setGame_type2] = useState(
    useLocation().pathname.split('/')[2]
  )
  const [Game_Ammount, setGame_Ammount] = useState('')

  //   console.log(game_type);

  const ChallengeCreate = e => {
    setIsloading(true)
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    axios
      .post(
        'https://api.kakaking.in/challange/create',
        {
          Game_Ammount,
          Game_type: game_type
        },
        { headers }
      )
      .then(res => {
        setGame_amt(res?.data?.data?.Game_Ammount)

        if (res.data.status == false) {
          setIsloading(false)
          Swal.fire({
            title: res.data.msg,
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        } else if (res.data.msg === 'you have already enrolled') {
          setIsloading(false)
          Swal.fire({
            title: 'You have already enrolled',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        } else if (res.data.msg === 'You can set maximum 2 battle.') {
          setIsloading(false)
          Swal.fire({
            title: 'You can set maximum 2 battle.',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        } else if (res.data.msg === 'Insufficient balance') {
          setIsloading(false)
          Swal.fire({
            title: 'Insufficient balance',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        } else if (
          res.data.msg ===
          'Game amount should be Greater then 50 and less then 50000'
        ) {
          setIsloading(false)
          Swal.fire({
            title: 'Game amount should be Greater then 50 and less then 50000',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        } else if (res.data.msg === 'Set Battle in denomination of 50') {
          setIsloading(false)
          Swal.fire({
            title: 'Set Battle in denomination of 50',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        } else if (res.data.msg === 'Technical Issue, Try after an hour!') {
          setIsloading(false)
          Swal.fire({
            title: 'Technical Issue, Try after an hour!',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        } else {
          setIsloading(false)
          // Allgames();
          // io.emit("gameCreated");
        }
      })
      .catch(e => {
        setIsloading(false)
        if (e?.response?.status == 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('token')
          window.location.reload()
          setTimeout(() => {
            //  history.push("/login")
          }, 500)
        }
        if (e?.response?.status == 400 || e?.response?.status == 429) {
          Swal.fire({
            title: 'Please refresh!',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
        console.log(e)
      })
  }

  const [allgame, setallgame] = useState([])
  const [mount, setMount] = useState(false)
  const [ALL, setALL] = useState()
  const [runningGames, setRunningGames] = useState([])
  const [ownRunning, setOwnRunning] = useState([])

  const Allgames = async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios
      .get('https://api.kakaking.in/challange/all', { headers })
      .then(res => {
        let owenedCreated = [],
          remainingGame = []
        res.data.forEach(function (ele) {
          if (
            ele.Created_by._id == user &&
            (ele.Status == 'new' || ele.Status == 'requested')
          ) {
            owenedCreated.push(ele)
          } else {
            remainingGame.push(ele)
          }
        })
        setCreated(owenedCreated)
        setallgame(remainingGame)
      })
      .catch(e => {
        if (e?.response?.status == 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('token')
          window.location.reload()
          setTimeout(() => {
            //  history.push("/login")
          }, 500)
        }
        if (e?.response?.status == 400 || e?.response?.status == 429) {
          Swal.fire({
            title: 'Please refresh!',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
      })
  }

  const runningGame = async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    axios
      .get('https://api.kakaking.in/challange/running/all', { headers })
      .then(res => {
        let owenedRunning = [],
          remainingRunning = []
        res.data.forEach(function (ele) {
          if (ele.Created_by && ele.Accepetd_By)
            if (
              ele.Created_by?._id == userID.current ||
              ele.Accepetd_By?._id == userID.current
            ) {
              owenedRunning.push(ele)
            } else {
              remainingRunning.push(ele)
            }
        })
        setOwnRunning(owenedRunning)
        setRunningGames(remainingRunning)
      })
      .catch(e => {
        console.log('errror', e)
        if (e.response?.status == 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('token')
          // window.location.reload()
          //    setTimeout(() => {
          // //  history.push("/login")
          // }, 500);
        }
        if (e.response?.status == 400 || e.response?.status == 429) {
          Swal.fire({
            title: 'Please refresh!',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
      })
  }






  function winnAmount(gameAmount) {
    let profit = 0;

    const commissionLudo = addCaseSetting?.commissionRangeludo || 10; // for 50–500
    const commissionAbove500 = addCaseSetting?.commissionRange2 || 5; // for >500
    if (gameAmount >= 50 && gameAmount <= 500) {
      profit = (gameAmount * commissionLudo) / 100; // use commissionRangeludo
    } else if (gameAmount > 500) {
      profit = (gameAmount * commissionAbove500) / 100; // use commissionRange2
    }

    return gameAmount - profit;
  }

  useEffect(() => {
    io.on('gamelist', data => {

      let owenedCreated = [],
        remainingGame = []
      data.forEach(function (ele) {
        if (ele.Created_by)
          if (
            ele.Created_by._id == userID.current &&
            (ele.Status == 'new' || ele.Status == 'requested')
          ) {
            owenedCreated.push(ele)
          } else {
            remainingGame.push(ele)
          }
      })
      // console.log('own',owenedCreated,'remiain',remainingGame);
      setCreated(owenedCreated)
      setallgame(remainingGame)
    })

    io.on('resultUpdateReq', data => {
      // console.log('resultUpdateReq')
      let owenedRunning = [],
        remainingRunning = []
      data.forEach(function (ele) {
        if (ele.Created_by && ele.Accepetd_By)
          if (
            ele.Created_by._id == userID.current ||
            ele.Accepetd_By._id == userID.current
          ) {
            owenedRunning.push(ele)
          } else {
            remainingRunning.push(ele)
          }
      })
      setOwnRunning(owenedRunning)
      setRunningGames(remainingRunning)
      walletUpdate()
    })
    io.on('startAcepptor', data => {
      // console.log('startAcepptor',data)
      let owenedCreated = [],
        remainingGame = []
      data.forEach(function (ele) {
        if (ele.Created_by)
          if (
            ele.Created_by._id == userID.current &&
            (ele.Status == 'new' || ele.Status == 'requested')
          ) {
            owenedCreated.push(ele)
          } else {
            remainingGame.push(ele)
          }
      })
      setCreated(owenedCreated)
      setallgame(remainingGame)
      walletUpdate()
    })

    io.on('acceptor_seen', data => {
      // console.log('acceptor_seen',data)
      let owenedCreated = [],
        remainingGame = []
      data.openBattle.forEach(function (ele) {
        if (ele.Created_by)
          if (
            ele.Created_by._id == userID.current &&
            (ele.Status == 'new' || ele.Status == 'requested')
          ) {
            owenedCreated.push(ele)
          } else {
            remainingGame.push(ele)
          }
      })
      setCreated(owenedCreated)
      setallgame(remainingGame)
      let owenedRunning = [],
        remainingRunning = []
      data.runningBattle.forEach(function (ele) {
        if (ele.Created_by && ele.Accepetd_By)
          if (
            ele.Created_by._id == userID.current ||
            ele.Accepetd_By._id == userID.current
          ) {
            owenedRunning.push(ele)
          } else {
            remainingRunning.push(ele)
          }
      })
      setOwnRunning(owenedRunning)
      setRunningGames(remainingRunning)
      walletUpdate()
    })
  }, [io])

  useEffect(() => {
    let access_token = localStorage.getItem('token')
    access_token = localStorage.getItem('token')
    if (!access_token) {
      window.location.reload()
      setTimeout(() => {
        //  history.push("/login")
      }, 500)
    }
    role()
    if (mount) {
      Allgames()
      runningGame()
    }
    return () => {
      role()
    }
  }, [mount])
  //accept Challange

  const AcceptChallang = id => {
    if (str == 1) {
      Swal.fire({
        title: 'Other request in process',
        icon: 'warning',
        confirmButtonText: 'OK'
      })
    }
    str = 1
    const access_token = localStorage.getItem('token')

    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    axios
      .put(
        `https://api.kakaking.in/challange/accept/${id}`,
        {
          Accepetd_By: headers,
          Acceptor_by_Creator_at: Date.now()
        },
        {
          headers
        }
      )
      .then(res => {
        setGameData({
          accept_by: res.data.Accepetd_By,
          created_by: res.data.Created_by
        })

        str = 0
        if (res.data.status === false) {
          Swal.fire({
            title: res.data.msg,
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
        if (res.data.msg === 'you have already enrolled') {
          Swal.fire({
            title: 'You have already enrolled',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
        if (res.data.msg === 'Insufficient balance') {
          Swal.fire({
            title: 'Insufficient balance',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        } else {
          // Allgames(res.data)
        }
      })
      .catch(e => {
        console.log(e)
        if (e.response.status == 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('token')
          window.location.reload()
          setTimeout(() => {
            //  history.push("/login")
          }, 500)
        }
        if (e.response.status == 400 || e.response.status == 429) {
          Swal.fire({
            title: 'Please refresh!',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
      })
  }

  //reject Game
  const RejectGame = id => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    axios
      .put(
        `https://api.kakaking.in/challange/reject/${id}`,
        {
          Accepetd_By: null,
          Status: 'new',
          Acceptor_by_Creator_at: null
        },
        { headers }
      )
      .then(res => {
        // io.emit("gameRejected");
      })
      .catch(e => {
        console.log(e)
        if (e.response.status == 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('token')
          window.location.reload()
          setTimeout(() => {
            //  history.push("/login")
          }, 500)
        }
        if (e.response.status == 400 || e.response.status == 429) {
          Swal.fire({
            title: 'Please refresh!',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
      })
  }

  //delete
  const deleteChallenge = _id => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    axios
      .delete(`https://api.kakaking.in/challange/delete/${_id}`, {
        headers
      })
      .then(res => {
        if (res.data.status == false) {
          Swal.fire({
            title: res.data.msg,
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
        // io.emit("deleteGame", _id);
      })
      .catch(e => {
        if (e?.response?.status == 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('token')
          window.location.reload()
          setTimeout(() => {
            //  history.push("/login")
          }, 500)
        }
        if (e.response.status == 400 || e.response.status == 429) {
          Swal.fire({
            title: 'Please refresh!',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
      })
  }

  ///challange/running/update/

  const updateChallenge = _id => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    axios
      .put(
        `https://api.kakaking.in/challange/running/update/${_id}`,
        {
          Acceptor_seen: true
        },
        { headers }
      )
      .then(res => {
        // io.emit("game_seen");
      })
      .catch(e => {
        if (e.response.status == 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('token')
          window.location.reload()
          setTimeout(() => {
            //  history.push("/login")
          }, 500)
        }
        if (e.response.status == 400 || e.response.status == 429) {
          Swal.fire({
            title: 'Please refresh!',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
        console.log(e)
      })
  }

  // const [roomCode, setRoomCode] = useState()

  const getPost = async Id => {
    if (
      game_type === 'Ludo Classics' ||
      game_type === 'Ludo 1 Goti' ||
      game_type === 'Ludo Ulta' ||
      // game_type === "Ludo Popular" ||
      game_type === 'Ludo Host'
    ) {
      if (submitProcess) {
        setProcess(false)
        setChallangeReqRun(true)

        const access_token = localStorage.getItem('token')

        const headers = {
          authorization: `Bearer ${access_token}`
        }

        axios
          .patch(
            `https://api.kakaking.in/challange/requested/running/${game_type}/` +
            Id,
            {},
            { headers }
          )
          .then(res => {
            setProcess(true)
            setChallangeReqRun(false)
            if (res.data.status == false) {
              Swal.fire({
                title: res.data.msg,
                icon: 'warning',
                confirmButtonText: 'OK'
              })
            } else {
              localStorage.setItem('timeOver', 'timeStart')
              history.push(`/viewgame1/${Id}`, {
                prevPath: window.location?.pathname
              })
            }
          })
          .catch(e => {
            setProcess(true)
            setChallangeReqRun(false)
            if (e?.response?.status == 401) {
              Swal.fire({
                title: 'Somthing wrong',
                icon: 'warning',
                confirmButtonText: 'OK'
              })
            } else {
              Swal.fire({
                title: 'Please refresh!',
                icon: 'warning',
                confirmButtonText: 'OK'
              })
            }
          })
      }

    } else if (
      game_type === 'LudoSnake' ||
      game_type === 'Ludo Popular' ||
      game_type === 'ludoClassicManual'
    ) {
      if (submitProcess) {
        setProcess(false)
        setChallangeReqRun(true)

        const access_token = localStorage.getItem('token')

        const headers = {
          authorization: `Bearer ${access_token}`
        }

        axios
          .patch(
            'https://api.kakaking.in/challange/requested/running/' + Id,
            {},
            { headers }
          )
          .then(res => {
            setProcess(true)
            setChallangeReqRun(false)
            if (res.data.status == false) {
              Swal.fire({
                title: res.data.msg,
                icon: 'warning',
                confirmButtonText: 'OK'
              })
            } else {
              localStorage.setItem('timeOver', 'timeStart')
              history.push(`/viewgame1/${Id}`, {
                prevPath: window.location?.pathname
              })
            }
          })
          .catch(e => {
            setProcess(true)
            setChallangeReqRun(false)
            if (e?.response?.status == 401) {
              Swal.fire({
                title: 'Somthing wrong',
                icon: 'warning',
                confirmButtonText: 'OK'
              })
            } else {
              Swal.fire({
                title: 'Please refresh!',
                icon: 'warning',
                confirmButtonText: 'OK'
              })
            }
          })
      }
    }
  }

  const [siteSetting, setsiteSetting] = useState([])

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem('sitSetting'))
    if (items) {
      setsiteSetting(items)
    }
  }, [])

  const [botTable, setBotTable] = useState([]);

  const getRandomSet = async () => {
    try {
      const access_token = localStorage.getItem("token");

      const res = await axios.get("https://api.kakaking.in/randomset", {
        headers: { Authorization: `Bearer ${access_token}` },
      });

      if (res.data.status === "success") {
        setBotTable(res.data.players);
      }
    } catch (err) {
      console.error("Error fetching random set:", err);
    }
  };

  useEffect(() => {
    getRandomSet();
  }, []);

  return (
    <>
      <Header user={userAllData} />
      <div className='leftContainer homepage-premium-page'>
        <div className='pt-5 mt-5 Orher_page_main_section homepage-premium-content'>
          <div className="site_message_main" style={{
            background: "#000000",
            color: '#fff',
            borderRadius: '12px',
            padding: '1px 10px',
            marginBottom: '20px',

            border: "5px solid rgb(211 170 88)"
          }}>
            <p>{siteSetting.ludoClassicsMsg}</p>
          </div>
          {/* create a battle input  box */}
          <div className='rules_btn d-flex justify-content-end premium-rules-row'>
            <Link to="/Rules">Rules</Link>

          </div>
          {(siteSetting?.gameSearch) && (
            <>
              <div className="create_battle_main_div corona-gradient-card premium-create-card">
                <div className="form-group">
                  <label>Open Battle !</label>
                </div>

                <div
                  className="craete_battle_input"
                  style={{ position: "relative" }}
                >
                  <input
                    type="text"
                    className="form-control common_input_box"
                    placeholder="Enter Amount"
                    inputMode="numeric"
                    value={Game_Ammount}
                    onChange={e => setGame_Ammount(e.target.value)}
                  />

                  {isLoading ? (
                    <img
                      src="/images/LandingPage_img/old-loader1.gif"
                      className="img-fluid create_battle_loader premium-loader"
                    />
                  ) : (
                    <button
                      className="create_battle_btn"
                      onClick={(e) => {
                        e.preventDefault();
                        setGame_Ammount("");
                        ChallengeCreate();
                      }}
                      style={{
                        position: "absolute",
                        right: "1px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        height: "30px",
                        padding: "0 12px",
                        borderRadius: "6px",
                        border: "none",
                        background: "#0b2c22",
                        color: "#fff",
                        cursor: "pointer",
                      }}
                    >
                      Set
                    </button>


                  )}
                </div>
              </div>
            </>
          )}
          {/* <div className={css.dividerX}></div> */}
          {/* <div  className="open_battle_headings">
            <h3 >
              <img src={process.env.PUBLIC_URL + '/images/Homepage/battleIcon.png'} className="img-fluid" />
              Open Battles
            </h3>
          </div> */}
          <div className="open_battle_headings">
            <span className="premium-battle-heading">
              <img
                src={process.env.PUBLIC_URL + '/images/battleIconbg.png'}
                className="premium-battle-icon"
              />
              Open Battles
            </span>
          </div>

          <div className=''>
            {created &&
              created.map(
                allgame =>
                  allgame.Game_type == game_type && (
                    <BetCard
                      key={allgame._id}
                      allgame={allgame}
                      user={user}
                      deleteChallenge={deleteChallenge}
                      getPost={getPost}
                      RejectGame={RejectGame}
                      challangeReqRun={challangeReqRun}
                      winnAmount={winnAmount}
                      AcceptChallang={AcceptChallang}
                      updateChallenge={updateChallenge}
                    />
                  )
              )}
            {allgame &&
              allgame.map(
                allgame =>
                  (allgame.Status == 'new' ||
                    (allgame.Status == 'requested' &&
                      (user == allgame.Created_by._id ||
                        user == allgame?.Accepetd_By?._id)) ||
                    (allgame?.Status == 'running' &&
                      user == allgame?.Accepetd_By?._id &&
                      allgame.Acceptor_seen == false)) &&
                  allgame.Game_type == game_type && (
                    <BetCard
                      key={allgame._id}
                      allgame={allgame}
                      user={user}
                      deleteChallenge={deleteChallenge}
                      getPost={getPost}
                      RejectGame={RejectGame}
                      winnAmount={winnAmount}
                      AcceptChallang={AcceptChallang}
                      updateChallenge={updateChallenge}
                    />
                  )
              )}
          </div>
          <div className="battle_devider"></div>
          <div className=''>
            <div className="open_battle_headings">
              <span className="premium-battle-heading">
                <img
                  src={process.env.PUBLIC_URL + '/images/battleIcon.png'}
                  className="img-fluid premium-battle-icon"
                />
                Running Battles
              </span>
            </div>

            {ownRunning &&
              ownRunning.map(runnig => {
                if (
                  ((user == runnig.Accepetd_By._id
                    ? (runnig.Status === 'running' &&
                      user == runnig.Accepetd_By._id &&
                      runnig.Acceptor_seen == true) ||
                    runnig.Status === 'pending'
                    : (runnig.Status === 'running' &&
                      user == runnig.Created_by._id) ||
                    runnig.Status === 'pending') ||
                    runnig.Status == 'conflict') &&
                  runnig.Game_type == game_type
                )
                  return (
                    <RunningCard
                      key={runnig._id}
                      runnig={runnig}
                      user={user}
                      winnAmount={winnAmount}
                    />
                  )
              })}

            {runningGames &&
              runningGames.map(runnig => {
                if (
                  (user == runnig.Accepetd_By._id ||
                    user == runnig.Created_by._id
                    ? user == runnig.Accepetd_By._id
                      ? (runnig.Status === 'running' &&
                        user == runnig.Accepetd_By._id &&
                        runnig.Acceptor_seen == true) ||
                      (runnig.Status === 'pending' &&
                        runnig.Acceptor_status == null)
                      : (runnig.Status === 'running' &&
                        user == runnig.Created_by._id) ||
                      (runnig.Status === 'pending' &&
                        runnig.Creator_Status == null)
                    : runnig.Status === 'running' ||
                    runnig.Status === 'pending') &&
                  runnig.Game_type == game_type
                ) {
                  return (
                    <>
                      <RunningCard
                        key={runnig._id}
                        runnig={runnig}
                        user={user}
                        winnAmount={winnAmount}
                      />
                    </>
                  )
                }
              })}



            {botTable &&
              botTable.map((running, index) => (
                <BotTable key={index} running={running} winnAmount={winnAmount} />
              ))}

          </div>
        </div>
      </div>
      <div className='rightContainer'>
        <Rightcontainer />
      </div>
    </>
  )
}
